import React from 'react';
import { useMeter8000Data } from '../../../../features/meter/hooks/useMeter';

export interface LocationNameMiniPresenterProps {
  deviceId?: string;
}

export default function LocationNameMiniPresenter({
  deviceId,
}: LocationNameMiniPresenterProps) {
  const { getMeterInfoLocalizationByMeterIdQuery } = useMeter8000Data(deviceId);

  if (getMeterInfoLocalizationByMeterIdQuery.isLoading) {
    return <>...</>;
  }

  const rawName = getMeterInfoLocalizationByMeterIdQuery.data?.minigridName?.trim();
  if (!rawName) return <>NA</>;
  return <>{rawName}</>;
}
